import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Paper } from '@mui/material';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    }
}));

interface CustomerTabsProps {
    page1: {
        label: string;
        content: React.ReactNode;
    };
    page2: {
        label: string;
        content: React.ReactNode;
    };
}

const CustomerTabs: React.FC<CustomerTabsProps> = ({ page1, page2 }) => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Paper>
                <AppBar position="static" elevation={0}>
                    <Tabs centered value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label={page1.label} {...a11yProps(0)} />
                        <Tab label={page2.label} {...a11yProps(1)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    {page1.content}
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {page2.content}
                </TabPanel>
            </Paper>
        </div>
    );
};

export default CustomerTabs;
